import { colors } from "../../../Styles";

export const getButtonStyles = (index: number, editTable: boolean) => {
  if (editTable && (index === 1 || index === 0)) {
    return { backgroundColor: colors.greyPrimary, opacity: 1 };
  }
  return { backgroundColor: colors.greySecondary, opacity: 0.5 };
};
